import {persianCopy} from './persianTranslations.js';
const localizedCopy = {
  "tr": [
    "Gelişmiş arama",
    "Sohbet soruları, konu başlıkları ve kitap künyelerinde arayın. Tam transkript veya kitap gövdesi araması ve doğrulanmış AI cevabı henüz sunulmuyor.",
    "Aranacak kelimeler",
    "Soru, konu veya eser…",
    "Kaynak türü",
    "Sohbetler ve Kütüphane",
    "Konu",
    "Tüm konular",
    "Yalnız hazır metne bağlı kayıtlar",
    "Sonuç yok. Kapsamı veya kelimeleri değiştirin.",
    "Kayıt bulundu",
    "İlk 30 kayıt gösteriliyor. Aramayı daraltın.",
    "Katalog ve yayın bilgisi",
    "Hazır metne bağlı kayıt"
  ],
  "en": [
    "Advanced search",
    "Search talk questions, topics and book catalogue entries. Full transcript or book-body search and verified AI answers are not available yet.",
    "Search terms",
    "Question, topic or work…",
    "Source type",
    "Talks and Library",
    "Topic",
    "All topics",
    "Only records linked to prepared text",
    "No results. Change the scope or terms.",
    "Records found",
    "Showing the first 30 records. Narrow your search.",
    "Catalogue and publication information",
    "Record linked to prepared text"
  ],
  "de": [
    "Erweiterte Suche",
    "Suchen Sie Gesprächsfragen, Themen und Buchkatalogeinträge. Volltextsuche in Transkripten oder Büchern und geprüfte KI-Antworten sind noch nicht verfügbar.",
    "Suchbegriffe",
    "Frage, Thema oder Werk…",
    "Quellentyp",
    "Gespräche und Bibliothek",
    "Thema",
    "Alle Themen",
    "Nur Einträge mit aufbereitetem Text",
    "Keine Ergebnisse. Umfang oder Begriffe ändern.",
    "Einträge gefunden",
    "Die ersten 30 Einträge werden angezeigt. Suche eingrenzen.",
    "Katalog- und Veröffentlichungsangaben",
    "Eintrag mit aufbereitetem Text"
  ],
  "fr": [
    "Recherche avancée",
    "Recherchez les questions, les sujets et les notices de livres. La recherche intégrale des transcriptions ou livres et les réponses IA vérifiées ne sont pas encore disponibles.",
    "Termes de recherche",
    "Question, sujet ou ouvrage…",
    "Type de source",
    "Entretiens et bibliothèque",
    "Sujet",
    "Tous les sujets",
    "Uniquement les notices liées à un texte préparé",
    "Aucun résultat. Modifiez le périmètre ou les termes.",
    "Notices trouvées",
    "Les 30 premières notices sont affichées. Affinez la recherche.",
    "Informations du catalogue et de publication",
    "Notice liée à un texte préparé"
  ],
  "es": [
    "Búsqueda avanzada",
    "Busque preguntas, temas y fichas de libros. La búsqueda de transcripciones o libros completos y las respuestas IA verificadas todavía no están disponibles.",
    "Términos de búsqueda",
    "Pregunta, tema u obra…",
    "Tipo de fuente",
    "Conversaciones y biblioteca",
    "Tema",
    "Todos los temas",
    "Solo registros vinculados a texto preparado",
    "Sin resultados. Cambie el alcance o los términos.",
    "Registros encontrados",
    "Se muestran los primeros 30 registros. Acote la búsqueda.",
    "Información de catálogo y publicación",
    "Registro vinculado a texto preparado"
  ],
  "ru": [
    "Расширенный поиск",
    "Поиск по вопросам, темам и каталогу книг. Поиск по полному тексту транскриптов и книг и проверенные ответы ИИ пока недоступны.",
    "Поисковые слова",
    "Вопрос, тема или произведение…",
    "Тип источника",
    "Беседы и библиотека",
    "Тема",
    "Все темы",
    "Только записи с подготовленным текстом",
    "Нет результатов. Измените область или слова.",
    "Найдено записей",
    "Показаны первые 30 записей. Уточните поиск.",
    "Сведения каталога и публикации",
    "Запись с подготовленным текстом"
  ],
  "ar": [
    "البحث المتقدم",
    "ابحث في أسئلة الأحاديث والموضوعات وفهرس الكتب. البحث في النصوص الكاملة للكتب والتفريغات وإجابات الذكاء الاصطناعي الموثقة غير متاحة بعد.",
    "كلمات البحث",
    "سؤال أو موضوع أو كتاب…",
    "نوع المصدر",
    "الأحاديث والمكتبة",
    "الموضوع",
    "كل الموضوعات",
    "السجلات المرتبطة بنص جاهز فقط",
    "لا نتائج. غيّر النطاق أو الكلمات.",
    "عدد السجلات",
    "تظهر أول 30 نتيجة. ضيّق البحث.",
    "بيانات الفهرس والنشر",
    "سجل مرتبط بنص جاهز"
  ],
  "zh": [
    "高级搜索",
    "搜索讲座问题、主题和图书目录。目前尚不提供转录或书籍全文搜索以及经过验证的人工智能回答。",
    "搜索词",
    "问题、主题或作品…",
    "来源类型",
    "讲座与图书馆",
    "主题",
    "所有主题",
    "仅显示关联已准备文本的记录",
    "没有结果。请更改范围或搜索词。",
    "找到的记录",
    "显示前30条记录。请缩小搜索范围。",
    "目录和出版信息",
    "关联已准备文本的记录"
  ]
};

localizedCopy.fa=persianCopy(localizedCopy.tr);
export default localizedCopy;
